module.exports = __webpack_public_path__ + "img/1-2.7fed5435.png";